import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import SingleCartItem from '../components/SingleCartItem';
import { useCtx } from '../context/AppContext';
import { injected } from '../components/connectors';
import useContract from '../hooks/useContracts';
import {
  Box,
  Button,
  Divider,
  Flex,
  Heading,
  HStack,
  Stack,
} from '@chakra-ui/react';
import WrapContent from '../components/WrapContent';

const Cart = () => {
  //eslint-disable-next-line

  const [balance, setBalance] = useState(0);

  const { cart, buyProduct, connect, isConnected } = useCtx();
  const costOfProducts = cart.reduce(
    (prev, curr) => prev + curr.price * curr.count,
    0
  );

  const productIds = cart.map(item => item.id);

  const shippingFee = 100;
  const discount = 50;

  const totalCost = costOfProducts + shippingFee - discount;

  const checkout = async () => {
    await buyProduct(1, 20);
    // if (balance < totalCost) {
    //   alert('Not enough funds!');
    //   return;
    // }
    // try {
    //   let contract = await marketPlace.connect(library.getSigner());
    //   // amount is not used in smart contract
    //   let tx = await contract.purchase(productIds, 1,
    //     totalCost * 1e6 )
    //     console.log(tx);
    // } catch (ex) {
    //   console.log(ex);
    // }
  };

  return (
    <Box>
      <WrapContent>
        <Box py="10">
          <Heading as="h1" fontSize="24px" fontWeight={'300'}>
            SHOPPING CART
          </Heading>
          <HStack justifyContent={'space-between'} py="5" alignItems={'center'}>
            {cart.length !== 0 && (
              <>
                <Button rounded="full" px="20px">
                  <Link to="/products">CONTINUE SHOPPING</Link>
                </Button>

                {isConnected ? (
                  <Button
                    colorScheme={'purple'}
                    onClick={checkout}
                    rounded="full"
                    px="20px"
                  >
                    Checkout now
                  </Button>
                ) : (
                  <Button
                    colorScheme={'purple'}
                    onClick={connect}
                    rounded="full"
                    px="20px"
                  >
                    Connect
                  </Button>
                )}
              </>
            )}
          </HStack>
          {cart.length === 0 && (
            <div
              style={{
                margin: 'auto',
                fontSize: '28px',
                width: 'fit-content',
              }}
            >
              Cart is empty.
              <br />
              <Link
                to="/products"
                style={{
                  fontSize: '20px',
                  color: 'teal',
                  padding: '30px 0',
                  textDecoration: 'underline',
                }}
              >
                Continue shopping
              </Link>
            </div>
          )}

          <Stack
            flexDir={['column', 'column', 'row']}
            justifyContent="space-between"
          >
            <Stack flex="3">
              {cart &&
                cart.map((item, index) => {
                  return <SingleCartItem key={index} item={item} />;
                })}

              <Divider />
            </Stack>
            {cart.length !== 0 && (
              <Stack
                spacing="5"
                flex="1"
                border="1px solid teal"
                rounded="md"
                p="10"
              >
                <Heading as="h1" fontSize={'20px'} fontWeight="400">
                  ORDER SUMMARY
                </Heading>
                <Flex justifyContent={'space-between'} fontSize="24px">
                  <Box as="span" fontSize="md">
                    SubTotal
                  </Box>
                  <Box as="span" fontSize="md">
                    {costOfProducts} USDT
                  </Box>
                </Flex>
                <Flex justifyContent={'space-between'} fontSize="24px">
                  <Box as="span" fontSize="md">
                    Estimated Shipping Cost
                  </Box>
                  <Box as="span" fontSize="md">
                    {shippingFee} USDT
                  </Box>
                </Flex>
                <Flex justifyContent={'space-between'} fontSize="24px">
                  <Box as="span" fontSize="md">
                    Shipping Discount
                  </Box>
                  <Box as="span" fontSize="md">
                    {discount} USDT
                  </Box>
                </Flex>
                <Flex
                  justifyContent={'space-between'}
                  fontSize="24px"
                  type="total"
                >
                  <Box as="span" fontSize="md">
                    Total
                  </Box>
                  <Box as="span" fontSize="md">
                    {totalCost} USDT
                  </Box>
                </Flex>
                {isConnected ? (
                  <Button
                    colorScheme={'purple'}
                    onClick={checkout}
                    rounded="full"
                    px="20px"
                  >
                    Checkout now
                  </Button>
                ) : (
                  <Button
                    colorScheme={'purple'}
                    onClick={connect}
                    rounded="full"
                    px="20px"
                  >
                    Connect
                  </Button>
                )}
              </Stack>
            )}
          </Stack>
        </Box>
      </WrapContent>
    </Box>
  );
};

export default Cart;
